import React from 'react';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import SecurityBanner from './components/SecurityBanner';

const LoginDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-muted/20 to-background">
      <div className="container-executive min-h-screen flex flex-col justify-center py-12">
        <div className="mb-8">
          <SecurityBanner />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="flex justify-center lg:justify-end">
            <LoginForm />
          </div>

          <div className="flex justify-center lg:justify-start">
            <TrustSignals />
          </div>
        </div>

        <footer className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {new Date()?.getFullYear()} I_SUKA DueDiligence. Hak Cipta Dilindungi.
            </p>
            <div className="flex items-center gap-6">
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Bantuan
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Kontak
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Dokumentasi
              </button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LoginDashboard;